import { capitalize } from "lodash";
import {
  formatDate,
  formatDateTime,
  formatTime,
} from "../../../../../../lib/time";
import { removeUnderscore } from "../../../../../../utils/string";
import { formatSLA } from "../../../../../../utils/utils";
import { TEMPLATE_TYPES } from "../../../constants/ticket.constants";
import { TabProps } from "./TicketDetailsTabs";

export const formatTicketStatus = (status: string, closedAt?: string) => {
  const formattedDate = closedAt
    ? `${formatTime(closedAt)}, ${formatDate(closedAt)}`
    : "";
  if (status === "active" || status === "opened")
    return `In-Progress ${formattedDate}`;
  return `${capitalize(status)} ${formattedDate}`;
};

export const mapTicketData = (ticketDetails: any) => {
  const {
    department,
    category,
    product,
    feature,
    created_at,
    workflow_status,
    priority,
    severity,
    totalSLA,
    raiser,
    closed_canceled_resolve_at,
    type,
  } = ticketDetails || {};

  const ticketData = {
    raisedBy: raiser?.officialInfo?.name,
    raisedDate: formatDateTime(created_at),
    ...(type === TEMPLATE_TYPES.workflow
      ? { department: department?.name || "N/A" }
      : {}),
    category: capitalize(category),
    sla: formatSLA(totalSLA),
    priority: capitalize(priority),
    ...(severity ? { severity: capitalize(severity) } : {}),
    ...(category === "product"
      ? {
          product: product?.title,
          feature: feature?.title,
        }
      : {}),
    status: `${capitalize(
      removeUnderscore(workflow_status),
    )} ${
      closed_canceled_resolve_at
        ? formatDateTime(closed_canceled_resolve_at)
        : ""
    }`,
  };
  return ticketData;
};

export const renderLabel = (key: string) => {
  const labels: Record<string, string> = {
    sla: "SLA",
    raisedBy: "Created By",
    raisedDate: "Created Date",
  };
  return labels[key] || key.replace(/([A-Z])/g, " $1");
};

export const getWorkflowDisplay = (workflow: any) => {
  if (!workflow) return "Workflow Completed";
  const employeeName = workflow?.employee?.officialInfo?.name;
  const roleType = workflow?.role_type ? capitalize(workflow.role_type) : "";
  return `${employeeName} (${roleType})`;
};

const TicketDetailsTab = ({ ticketDetails }: TabProps) => {
  if (!ticketDetails) return null;
  const ticketData = mapTicketData(ticketDetails);

  const workflowDisplay = getWorkflowDisplay(ticketDetails?.currentWorkflow);
  return (
    <div className="h-[calc(100vh_-_385px)] w-full overflow-auto">
      <table className="w-full">
        <tbody>
          {Object.entries(ticketData).map(([key, value]) => (
            <tr key={key} className="text-base">
              <td className="px-4 py-2 font-medium capitalize text-[#455468]">
                {renderLabel(key)}
              </td>
              <td className="px-4 py-2 text-[#2D3643] font-medium">
                :{" "}
                {value === "Closed"
                  ? "Completed"
                  : Array.isArray(value)
                  ? value.join(", ")
                  : value}
              </td>
            </tr>
          ))}
          <tr className="text-base">
            <td className="px-4 py-2 font-medium capitalize text-[#455468] text-nowrap">
              Currently Assigned
            </td>
            <td className="px-4 py-2 text-[#2D3643] font-medium">
              : {workflowDisplay}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TicketDetailsTab;
